var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundInvestorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2771_12265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 6C5 2.691 7.691 0 11 0C14.309 0 17 2.691 17 6C17 9.309 14.309 12 11 12C7.691 12 5 9.309 5 6ZM21.685 16.267L18.644 15.76C18.271 15.698 18 15.378 18 15C18 14.449 18.448 14 18.999 14L21.27 14.003C21.63 14.003 21.954 14.19 22.136 14.503C22.412 14.98 23.026 15.143 23.503 14.865C23.981 14.588 24.143 13.975 23.864 13.498C23.328 12.576 22.334 12.003 21.27 12.003H20.999V11C20.999 10.448 20.552 10 19.999 10C19.446 10 18.999 10.448 18.999 11V12C17.345 12 15.999 13.346 15.999 15C15.999 16.36 16.973 17.51 18.314 17.733L21.355 18.24C21.728 18.302 21.999 18.622 21.999 19C21.999 19.551 21.551 20 21 20L18.73 19.998C18.374 19.998 18.042 19.807 17.864 19.499C17.588 19.021 16.975 18.859 16.498 19.135C16.019 19.412 15.856 20.024 16.134 20.502C16.669 21.425 17.663 21.998 18.73 21.998H19V23C19 23.552 19.447 24 20 24C20.553 24 21 23.552 21 23V22C22.654 22 24 20.654 24 19C24 17.64 23.026 16.49 21.685 16.267ZM14.405 21.505C14.003 20.812 13.895 20.003 14.101 19.228C14.246 18.687 14.531 18.208 14.925 17.832C14.34 17.037 14 16.056 14 15C14 14.843 14.032 14.695 14.046 14.542C13.093 14.198 12.07 14 11 14C6.037 14 2 18.038 2 23C2 23.552 2.447 24 3 24H17.184C17.15 23.905 17.118 23.809 17.094 23.709C15.98 23.32 15.012 22.553 14.404 21.504L14.405 21.505Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2771_12265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundInvestorIcon);
export default __webpack_public_path__ + "static/media/round_investor_icon.44d5149d128c022bf4136ea746a46edf.svg";
export { ForwardRef as ReactComponent };